import PropTypes from 'prop-types';

import placeholder from 'lib/placeholder';
import { userPreferencesQueryKeys } from 'lib/queryKeys';

import {
  getUserEmailPreferences,
  postUserEmailPreference,
} from 'services/permissions';

import Settings from '../Settings';
import Skeleton from './Skeleton';

const SETTINGS = [
  {
    title: 'Alerta de Promoções',
    options: [
      {
        id: 'wishlist_product',
        label: 'Nova oferta da Lista de Desejos',
      },
      {
        id: 'wishlist_hidden',
        label: 'Receber recomendações de ofertas',
      },
    ],
  },
  {
    title: 'Fórum',
    options: [
      {
        id: 'thread_received',
        label: 'Um tópico que criei receber comentários',
      },
      {
        id: 'thread_marked',
        label: 'Me marcarem em um comentário de um tópico',
      },
    ],
  },
  {
    title: 'Alerta de Cupons',
    options: [
      {
        id: 'wishlist_coupon',
        label: 'Novo cupom da Lista de Desejos',
      },
    ],
  },
  {
    title: 'Blog',
    options: [
      {
        id: 'blog_marked',
        label: 'Me marcarem em um comentário no blog',
      },
    ],
  },
  {
    title: 'Ofertas',
    options: [
      {
        id: 'comment_received',
        label: 'Uma oferta que publiquei receber comentários',
      },
      {
        id: 'comment_marked',
        label: 'Me marcarem em um comentário de uma oferta',
      },
      {
        id: 'comment_replied',
        label: 'Me responderem em um comentário de uma oferta',
      },
    ],
  },
  {
    title: 'Mensagens',
    options: [
      {
        id: 'message_received',
        label: 'Quando eu receber mensagens do Promobit',
      },
    ],
  },
];

const EmailAlertsSettings = ({ className }) => (
  <Settings
    className={className}
    mutationFn={postUserEmailPreference}
    queryFn={getUserEmailPreferences}
    queryKey={userPreferencesQueryKeys.email()}
    settings={SETTINGS}
    skeleton={Skeleton}
    subscribedKey="mailSubscribed"
    title={placeholder('titles.emailAlerts')}
    unsubscribedKey="mailUnsubscribed"
  />
);

EmailAlertsSettings.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default EmailAlertsSettings;
